const defaultNs = 'http://www.w3.org/2000/svg';
class Base {
	constructor() {
		this.listeners = {};
	}	
	makeElement(name, ...attribs) {
		let elem;
		if ((attribs && attribs[0] && attribs[0].xmlns) || (name && name.toLowerCase() === 'svg')) {
			const attrNs = attribs[0].xmlns;
			const ns = typeof attrNs === 'string' ? attrNs : defaultNs;
			elem = document.createElementNS(ns, name);
			elem.setAttribute('xmlns', attrNs);
		} else {
			elem = document.createElement(name);
		}

		attribs.slice(0).forEach(attribute => {
			if(typeof(attribute)==='string') {
				attribute.split(' ').forEach(className => elem.classList.add(className));
			} else if (attribute instanceof Node || attribute instanceof Array ) {
				[].concat(attribute).forEach(node => {
					if (node) elem.appendChild((typeof node === 'string' || typeof node === 'number') ? document.createTextNode(node) : node);
				});
			} else if(typeof(attribute)==='object') {
				for(const k in attribute) {
					elem[k] = attribute[k];
				}
			}
		});

		return elem;
	}

	matches(element, selector) {
		if (element.matches) {
			return element.matches(selector);
		} else if (element.matchesSelector) {
			return element.matchesSelector(selector);
		} else if (element.msMatchesSelector) {
			return element.msMatchesSelector(selector);
		} else if (element.webkitMatchesSelector) {
			return element.webkitMatchesSelector(selector);
		}
		return false;
	}

	subscribe(eventName, listener, context) {
		(this.listeners[eventName] = this.listeners[eventName] || []).push({
			func: listener,
			context: context
		});
	}

	emit(eventName, ...arg) {
		for(const listener of (this.listeners[eventName] || [])) {
			listener.func.apply(listener.context, arg);
		}
	}
}

export default Base;
